/**
 * Centralised React Query key factory for the V3 mailbox module.
 * All keys are namespaced under 'mailboxV3' to prevent collisions with V1/V2 cache entries.
 *
 * Usage:
 *   queryClient.invalidateQueries({ queryKey: mailboxV3Keys.all })      // bust everything
 *   queryClient.invalidateQueries({ queryKey: mailboxV3Keys.threads() }) // bust list only
 *   queryClient.setQueryData(mailboxV3Keys.threadDetail(pk, sk), updater)
 */

export const mailboxV3Keys = {
  /** Root key — invalidates all V3 mailbox queries */
  all: ['mailboxV3'],

  /** Thread list queries (infinite scroll) */
  threads: (filters) => ['mailboxV3', 'threads', filters],

  /** Single thread detail query */
  threadDetail: (pk, sk) => ['mailboxV3', 'thread', pk, sk],
};
